import {collection, doc, DocumentReference} from "@firebase/firestore";
import {db} from "../config/firebase-config";

export abstract class PaypalSessionUtils {
    public static getNewPaypalSessionRef(uid: string): DocumentReference {
        return doc(collection(db, `users/${uid}/paypal_sessions`));
    }
}
